<nav-bar titulo="Diária Adicional"
         [iconeNotificacoes]="false"
         [botaoMenu]="true"
         [botaoPainelAplicacoes]="true"
         (logoutEvent)="logout($event)"
         [linkPainelAplicacoes]="URL_LOGIN">
</nav-bar>
<menu-lateral [itensMenu]="menuItens">
    <copyright></copyright>
</menu-lateral>
